import React, { useContext } from "react";
import { ProductContext } from "../../context";
import { orders } from './orders';
import { OrderLine } from "./OrderLine";
import { CssFormGroup, CssPopSection, CssH1 } from "./../uikit-b2c/uikit-b2c";
export const UserAccountSubscriptions = () => {
  const valueFromContext = useContext(ProductContext);
  return (<React.Fragment>
    <CssFormGroup alignment="center">

      <CssPopSection theme={valueFromContext.getTheme()}>

        <CssFormGroup indentation="lg">
          <CssH1>My subscriptions</CssH1>
        </CssFormGroup>


        {orders['orders'].map((oneOrder, ind) => {
          return <OrderLine
          key={`order_${oneOrder['operation_id']}`}
          purchase={oneOrder['purchase']}
          filter="subscription"
          image="./public/img/ic_coins_subs.svg" />;
        })}

      </CssPopSection>
    </CssFormGroup>
  </React.Fragment>);
};
